import { render } from "./AdminsTable.vue?vue&type=template&id=4ae91644&scoped=true"
import script from "./AdminsTable.vue?vue&type=script&lang=js"
export * from "./AdminsTable.vue?vue&type=script&lang=js"

import "./AdminsTable.vue?vue&type=style&index=0&id=4ae91644&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ae91644"]])

export default __exports__